import { useNavigate, useParams } from 'react-router'

import { PROFILE_ROUTE_NAMES } from '../../../../../../constants/route'
import { useListingProfileContext } from '../useListingProfileContext'

import { LISTING_OVERVIEW_TAB_SEGMENT } from './useListingProfileEditBlockOpener.constants'
import { getIsNotListingOverviewTab } from './useListingProfileEditBlockOpener.utils'

export function useListingProfileEditBlockOpener() {
  const navigate = useNavigate()
  const { tab } = useParams()

  const { listingData, setBlockToEdit } = useListingProfileContext()

  const canEditBlocks = Boolean(listingData?.permissions?.can_edit)

  function handleOpenEditBlock(blockId) {
    if (tab && getIsNotListingOverviewTab(tab)) {
      navigate(
        PROFILE_ROUTE_NAMES.rentalPortalListingProfile({
          additionalParams: `/${LISTING_OVERVIEW_TAB_SEGMENT}`,
          id: listingData.id,
        })
      )
    }

    setBlockToEdit(blockId)
  }

  return { canEditBlocks, handleOpenEditBlock }
}
